import { useTranslation } from 'react-i18next';
import { landingMedia } from './media';

export default function StepsSection() {
  const { t } = useTranslation('landing');

  const steps: Array<{ n: string; image: string; alt: string; title: string; body: string }> = [
    {
      n: '01',
      image: landingMedia.steps.create,
      alt: t('steps.create.alt', 'Character placing a new block on an island'),
      title: t('steps.create.title', 'Create your game'),
      body: t(
        'steps.create.body',
        'Describe what you want to build. Entire’s agents create the game, systems, assets, and backend, while you keep shaping it through conversation.',
      ),
    },
    {
      n: '02',
      image: landingMedia.steps.launch,
      alt: t('steps.launch.alt', 'Character launching a rocket'),
      title: t('steps.launch.title', 'Launch it for real'),
      body: t(
        'steps.launch.body',
        'Build for mobile and PC, configure monetization, and publish to Google Play, the App Store, or Steam.',
      ),
    },
    {
      n: '03',
      image: landingMedia.steps.grow,
      alt: t('steps.grow.alt', 'Character overlooking a world with player analytics'),
      title: t('steps.grow.title', 'Turn players into progress'),
      body: t(
        'steps.grow.body',
        'See how people play, understand what works, and use Entire’s agents to improve the game, run LiveOps, and keep growing.',
      ),
    },
  ];

  return (
    <section id="create" style={{ padding: '48px var(--gutter) 0', scrollMarginTop: 'var(--header-h)' }}>
      <h2 className="t-h2" style={{ margin: '0 0 18px', maxWidth: 820 }}>
        {t('steps.titleA', 'Describe it.')}
        <br />
        <span className="t-accent">{t('steps.titleB', 'Launch it. Grow it.')}</span>
      </h2>
      <p className="t-body" style={{ fontSize: 'var(--fs-body)', margin: '0 0 48px', maxWidth: 620 }}>
        {t(
          'steps.lede',
          'Start with your idea. Entire’s agents handle the code, assets, game systems and backend, so you can focus on the game itself and keep building with every new idea.',
        )}
      </p>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(270px, 1fr))', gap: 'var(--gap-grid-lg)' }}>
        {steps.map((s) => (
          <div key={s.n} style={{ minWidth: 0 }}>
            <div className="frame" style={{ marginBottom: 20 }}>
              <div className="frame-inner" style={{ aspectRatio: '3 / 2' }}>
                <img src={s.image} alt={s.alt} loading="lazy" />
              </div>
            </div>
            <span className="t-num">{s.n}</span>
            <h3 className="t-h3" style={{ margin: '10px 0 9px' }}>
              {s.title}
            </h3>
            <p className="t-body" style={{ margin: 0 }}>
              {s.body}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
}
